/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free age calculator — find your exact age in years, months and days, plus total days, the day you were born, and days to your next birthday.`)
};

const es_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de edad gratuita — encuentra tu edad exacta en años, meses y días, más días totales, el día en que naciste y días para tu próximo cumpleaños.`)
};

const de_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Altersrechner — finden Sie Ihr genaues Alter in Jahren, Monaten und Tagen, plus Gesamttage, den Tag Ihrer Geburt und Tage bis zu Ihrem nächsten Geburtstag.`)
};

const nl_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis leeftijdscalculator — vind uw exacte leeftijd in jaren, maanden en dagen, plus totale dagen, de dag waarop u bent geboren en dagen tot uw volgende verjaardag.`)
};

const fr_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'âge gratuite — trouvez votre âge exact en années, mois et jours, plus le nombre total de jours, le jour où vous êtes né, et les jours jusqu'à votre prochain anniversaire.`)
};

const it_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore dell'età gratuito — trova la tua età esatta in anni, mesi e giorni, più i giorni totali, il giorno in cui sei nato/a e i giorni al tuo prossimo compleanno.`)
};

const pt_br2_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de idade grátis — encontre sua idade exata em anos, meses e dias, além do total de dias, o dia em que nasceu e dias até seu próximo aniversário.`)
};

const pt_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de idade gratuita — encontre a sua idade exata em anos, meses e dias, mais o total de dias, o dia em que nasceu e os dias até ao seu próximo aniversário.`)
};

const ja_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の年齢計算機 - 正確な年齢（年、月、日）と総日数、生まれた日付、次の誕生日までの日数を確認してください。`)
};

const zh_age_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费年龄计算器——精确计算您以年、月、日表示的年龄，以及总天数、出生当天是星期几，以及距离下一个生日的天数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_tool_description", locale)
	if (locale === "en") return en_age_tool_description(inputs)
	if (locale === "es") return es_age_tool_description(inputs)
	if (locale === "de") return de_age_tool_description(inputs)
	if (locale === "nl") return nl_age_tool_description(inputs)
	if (locale === "fr") return fr_age_tool_description(inputs)
	if (locale === "it") return it_age_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_age_tool_description(inputs)
	if (locale === "pt") return pt_age_tool_description(inputs)
	if (locale === "ja") return ja_age_tool_description(inputs)
	return zh_age_tool_description(inputs)
};